<template>
  <div>
    <h4>Datos de la empresa :</h4>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          type="text"
          v-model="emailEmpresa"
          :rules="textRules"
          label="Correo de la empresa"
          required
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          type="text"
          v-model="direccionEmpresa"
          :rules="textRules"
          label="Direccion de la empresa"
          required
          outlined
        ></v-text-field>
      </v-col>
       <v-col cols="12" md="6">
        <v-text-field
          type="text"
          v-model="telefonoEmpresa"
          :rules="textRules"
          label="Telefono de la empresa"
          required
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Datosempresa",
  data() {
    return {
      emailEmpresa: "",
      direccionEmpresa: "",
      nombreEmpresa: "",
      telefonoEmpresa: ""
    };
  },
  computed: {
    ...mapState(["numberRules", "textRules"])
  },
  methods:{
    ...mapActions(["cargarEmailEmpresa","cargarDireccionEmpresa","cargarTelefonoEmpresa"])
  },
   watch: {
    emailEmpresa: function(newValue) {
      this.cargarEmailEmpresa(newValue)
    },
     direccionEmpresa: function(newValue) {
      this.cargarDireccionEmpresa(newValue)
    },
   telefonoEmpresa: function(newValue) {
      this.cargarTelefonoEmpresa(newValue)
    }
  
  
  },
};
</script>